import { clearImpersonationStorage } from "features/permissions/permissionImpersonation.ts";

export const LOGIN_UI_VERSION_KEY = "loginUiVersion";
export const LOGIN_API_VERSION_KEY = "loginApiVersion";

export const clearAuthenticationSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("permissions");
  sessionStorage.removeItem("loginBypass");
  sessionStorage.removeItem("username");
  localStorage.removeItem(LOGIN_UI_VERSION_KEY);
  localStorage.removeItem(LOGIN_API_VERSION_KEY);
  clearImpersonationStorage();
};

export const normalizeVersion = (version?: string | null) =>
  version?.trim() || null;

export const hasVersionChanged = (
  loginVersion?: string | null,
  currentVersion?: string | null,
) => {
  const normalizedLoginVersion = normalizeVersion(loginVersion);
  const normalizedCurrentVersion = normalizeVersion(currentVersion);

  return Boolean(
    normalizedLoginVersion &&
    normalizedCurrentVersion &&
    normalizedLoginVersion !== normalizedCurrentVersion,
  );
};
